// extracted by css-extract-rspack-plugin
export default {"root":"FilterPill-module__root___UZYdN","readOnly":"FilterPill-module__readOnly___TDWIl","icon":"FilterPill-module__icon___NmvuX"};